<template>
  <article>
    <LoaderStack v-if="isLoading" />
    <template v-else>
      <AreaNewsBanner />
      <AreaNewsFeature />
      <AreaNewsResources />
      <AreaNewsFooter />
    </template>
  </article>
</template>

<script setup lang="ts">
  definePageMeta({
    middleware: [
      (to) => {
        const { $i18n } = useNuxtApp();
        const { locale } = $i18n;

        if (to.query.page === '1') {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { page, ...restQuery } = to.query;
          return navigateTo(
            {
              path: `/${locale.value}/marketplace/news`,
              query: restQuery,
            },
            { redirectCode: 301 }
          );
        }
      },
    ],
  });

  const { t } = useI18n({ useScope: 'local' });
  const newsStore = useNewsStore();
  const { provideWebTitle } = useWebsite();

  const { status: GET_FEATURED_RESOURCE_STATUS } =
    await newsStore.USE_GET_FEATURED_RESOURCE();

  const isLoading = computed(
    (): boolean => GET_FEATURED_RESOURCE_STATUS.value === 'pending'
  );

  useSeoMeta({
    title: t('seo-title'),
    ogTitle: () => provideWebTitle(t('seo-title')),
    twitterTitle: () => provideWebTitle(t('seo-title')),
    description: () => t('seo-description'),
    ogDescription: () => t('seo-description'),
    twitterDescription: () => t('seo-description'),
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "en-jp": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "en-tw": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "en-kr": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "en-americas": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "en-asia-pacific": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "en-emea": {
    "seo-title": "News & Knowledge Hub",
    "seo-description": "Stay informed with the latest news and resources from our industry knowledge hub."
  },
  "ja-jp": {
    "seo-title": "ニュースと情報センター",
    "seo-description": "最新ニュースや業界の情報で、ビジネスをリードするヒントを手に入れましょう。"
  },
  "zh-cn": {
    "seo-title": "新闻中心",
    "seo-description": "获取最新行业新闻和洞察，助您做出明智的商业决策。"
  },
  "zh-tw": {
    "seo-title": "新聞與資訊中心",
    "seo-description": "探索最新的新聞、更新及深入洞察，助您領先市場趨勢。"
  }
}
</i18n>
